import React, { useState } from 'react'
import { branch } from 'baobab-react/higher-order'
import { cookie } from 'cookie_js'

import BaseTemplate from 'components/templates/BaseTemplate'
import config from 'config'

import Button from 'components/atoms/Button'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'
import Paper from 'components/atoms/Paper'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import { Alert, Checkbox } from 'components/qstrap'
import AlertSVG from 'components/atoms/SVGIcons/Alert'

const PaperplaneReview = ({ prediction, option1, option2, scores }) => {
  const [isChecked, setChecked] = useState(false)

  const reviewClick = () => {
    cookie.set({
      paperplane_review_agree: true,
    }, {
      domain: config.auth_token_cookie_domain,
      path: '/',
    })
    window.location = '/peluang-sbmptn/result'
  }
  const namingCategory = {
    soshum: 'Soshum',
    saintek: 'Saintek',
    mix: 'Campuran (IPC)',
  }

  return (
    <BaseTemplate>
      <div className="paperplane-review">
        <Container mobileFull>
          <Paper shadowed>
            <div className="paperplane-review__form">
              <Alert color="warning">
                <span className="paperplane-review__alert-icon"><AlertSVG fill="#fc7d20" /></span>
                [Penting] Data nilai yang tertera di bawah ini merupakan nilai tryout kamu yang telah dihitung dengan system penilaian IRT (Item Response Theory).
              </Alert>

              <Typography component="h1" variant="title" className="text-variant-title-sm">
                Review Nilai UTBK
              </Typography>
              {prediction && scores && (
                <div className="score-review">
                  <Row>
                    <Col xs="8">
                      <Typography component="span" variant="body" className="summary-text">
                        Kelompok Ujian
                      </Typography>
                    </Col>
                    <Col xs="4" className="text-right">
                      <Typography component="span" variant="body" className="summary-text bold">
                        {namingCategory[prediction.category]}
                      </Typography>
                    </Col>
                  </Row>
                  {Object.keys(scores.tps).length !== 0 && (
                    <div className="subject-group">
                      <Typography component="p" variant="body" className="bold subject-group__name">
                        Nilai TPS
                      </Typography>
                      {
                        scores.tps.map((item, idx) => (
                          <Row key={`tps-${idx}`}>
                            <Col xs="8">
                              <Typography component="span" variant="body" className="summary-text">
                                {item.type}
                              </Typography>
                            </Col>
                            <Col xs="4" className="text-right">
                              <Typography component="span" variant="body" className="summary-text bold">
                                {item.score}
                              </Typography>
                            </Col>
                          </Row>
                        ))
                      }
                    </div>
                  )}
                  {prediction.category !== 'soshum' && Object.keys(scores.saintek).length !== 0 && (
                    <div className="subject-group">
                      <Typography component="p" variant="body" className="bold subject-group__name">
                        Nilai Saintek
                      </Typography>
                      {
                        scores.saintek.map((item, idx) => (
                          <Row key={`saintek-${idx}`}>
                            <Col xs="8">
                              <Typography component="span" variant="body" className="summary-text">
                                {item.type}
                              </Typography>
                            </Col>
                            <Col xs="4" className="text-right">
                              <Typography component="span" variant="body" className="summary-text bold">
                                {item.score}
                              </Typography>
                            </Col>
                          </Row>
                        ))
                      }
                    </div>
                  )}
                  {prediction.category !== 'saintek' && Object.keys(scores.soshum).length !== 0 && (
                    <div className="subject-group">
                      <Typography component="p" variant="body" className="bold subject-group__name">
                        Nilai Soshum
                      </Typography>
                      {
                        scores.soshum.map((item, idx) => (
                          <Row key={`tps-${idx}`}>
                            <Col xs="8">
                              <Typography component="span" variant="body" className="summary-text">
                                {item.type}
                              </Typography>
                            </Col>
                            <Col xs="4" className="text-right">
                              <Typography component="span" variant="body" className="summary-text bold">
                                {item.score}
                              </Typography>
                            </Col>
                          </Row>
                        ))
                      }
                    </div>
                  )}
                </div>
              )}
            </div>
          </Paper>
          <Paper shadowed>
            <div className="paperplane-review__form">
              <Typography component="h1" variant="title" className="text-variant-title-xs">
                Review Universitas dan Jurusan
              </Typography>
              {option1 && (
                <div className="subject-group">
                  <Typography component="p" variant="body" className="bold subject-group__name">
                    Pilihan 1
                  </Typography>
                  <Row>
                    <Col xs="5">
                      <Typography component="span" variant="body" className="summary-text">
                        Universitas
                      </Typography>
                    </Col>
                    <Col xs="7" className="text-right">
                      <Typography component="span" variant="body" className="summary-text bold">
                        { option1.campus_name }
                      </Typography>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="5">
                      <Typography component="span" variant="body" className="summary-text">
                        Jurusan
                      </Typography>
                    </Col>
                    <Col xs="7" className="text-right">
                      <Typography component="span" variant="body" className="summary-text bold">
                        { option1.name }
                      </Typography>
                    </Col>
                  </Row>
                </div>
              )}
              {option2 && (
                <div className="subject-group">
                  <Typography component="p" variant="body" className="bold subject-group__name">
                    Pilihan 2
                  </Typography>
                  <Row>
                    <Col xs="5">
                      <Typography component="span" variant="body" className="summary-text">
                        Universitas
                      </Typography>
                    </Col>
                    <Col xs="7" className="text-right">
                      <Typography component="span" variant="body" className="summary-text bold">
                        { option2.campus_name }
                      </Typography>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="5">
                      <Typography component="span" variant="body" className="summary-text">
                        Jurusan
                      </Typography>
                    </Col>
                    <Col xs="7" className="text-right">
                      <Typography component="span" variant="body" className="summary-text bold">
                        { option2.name }
                      </Typography>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Paper>
          <div className="paperplane-review__control">
            <Checkbox checked={isChecked} onChange={() => setChecked(!isChecked)} disabled={scores && Object.keys(scores).length === 0}>
              <p style={{ fontSize: '14px', marginLeft: '24px', fontWeight: 'normal' }}>
                Saya setuju bahwa hasil Cek Peluang SBMPTN ini merupakan prediksi dan tidak menjamin hasil akhir SBMPTN 2021 saya.
              </p>
            </Checkbox>
            <Button
              component="button"
              type="button"
              variant="default"
              disabled={!isChecked}
              onClick={reviewClick}
              className="paperplane-review__button"
            >
              Submit
            </Button>
          </div>
        </Container>
      </div>
      <style jsx>
        {`
          .paperplane-review {
            &__form {
              padding: 40px;
              color: #1a344f;
              :global(.alert-warning) {
                margin-bottom: 1.5rem !important;
                span {
                  font-size: 12px;
                }
              }
            }
            &__alert-icon {
              margin-right: 8px;
            }
            &__control {
              display: flex;
              margin: 1.5rem 0;
            }
            :global(&__modal) {
              padding: 40px;
              color: #1a344f;
              display: flex;
              flex-direction: column;
            }
            :global(&__button) {
              margin-left: auto !important;
            }
            :global(&__modal-wrapper) {
              margin-top: 200px;
            }
            :global(&__modal-title) {
              font-weight: bold;
              margin-bottom: 1.5rem;
            }
            @media screen and (max-width: 767px) {
              &__form {
                padding: 24px 16px;
                :global(h1) {
                  font-size: 24px !important;
                  margin-bottom: 1rem !important;
                }
              }
              &__control {
                flex-direction: column;
                padding: 0 16px;
              }
              :global(&__modal-wrapper) {
                margin: 200px 24px 0 24px;
              }
              :global(&__modal) {
                padding: 16px;
                text-align: center;
                :global(span) {
                  font-size: 14px !important;
                }
              }
              :global(&__modal-title) {
                font-size: 16px !important;
                margin-bottom: 1rem !important;
              }
              :global(&__button) {
                margin-left: 0 !important;
                font-size: 14px !important;
                padding: 10px 0 !important;
              }
            }
          }
          .score-review {
            :global(.summary-text) {
              display: inline-block;
            }
          }
          .subject-group {
            margin-top: 2.5rem;
            :global(&__name) {
              margin-bottom: 1.5rem !important;
            }
            :global(.summary-text) {
              display: inline-block;
            }
            :global(.cmps-row:not(:first-of-type)>.cmps-col>.summary-text) {
              margin-top: 1.5rem;
            }
            @media screen and (max-width: 767px) {
              margin-top: 1.5rem;
            }
          }
          :global(.modal-content) {
            box-shadow: none;
          }
          :global(.modal-backdrop) {
            background-color: #1a344f;
            opacity: 0.8;
          }
          :global(.alert) {
            background-color: #fff0e6;
            font-size: 12px;
            display: flex;
          }
          :global(.button) {
            margin-left: 16px;
            font-size: 16px;
            font-weight: bold;
            padding: 16px 32px;
            border: none;
          }
          :global(.button[disabled]) {
            background-color: #d3dce6;
            cursor: not-allowed;
          }
          :global(.checkbox-indicator) {
            width: 16px;
            height: 16px;
            margin-top: 3px;
          }
          :global(.checkbox) {
            padding: 0;
          }
          :global(.campus-paper:not(:first-of-type)) {
            margin-top: 24px;
          }
          :global(.text-right) {
            text-align: right;
          }
        `}
      </style>
    </BaseTemplate>
  )
}

export default branch({
  prediction: ['serverProps', 'prediction'],
  scores: ['serverProps', 'scores'],
  option1: ['serverProps', 'option_1'],
  option2: ['serverProps', 'option_2'],
}, PaperplaneReview)
